export const SET_ISSUES = 'SET_ISSUES';
export const CLEAR_ISSUES = 'CLEAR_ISSUES';
export const SET_ISSUE_LIST_OPTIONS = 'SET_ISSUE_LIST_OPTIONS';
export const SET_ISSUES_INNER_DATA = 'SET_ISSUES_INNER_DATA';
export const CLEAR_ISSUES_INNER_DATA = 'CLEAR_ISSUES_INNER_DATA';
export const SET_ISSUE_DETAILS = 'SET_ISSUE_DETAILS';
export const CLEAR_ISSUE_DETAILS = 'CLEAR_ISSUE_DETAILS';
